export function STooltipWrapper({ children, uniqueId, tooltipContent, disabled }: STooltipWrapperProps) {
    return (
        <div className="relative" onClick={(e) => e.stopPropagation()}>
            {children}
            <div className={`absolute top-0 right-0 left-0 bottom-0 z-50 opacity-0 cursor-default`}>
                <s-clickable
                    interestFor={`tooltip-${uniqueId}`}
                    inlineSize="100%"
                    blockSize="100%"
                    disabled={disabled}
                ></s-clickable>
            </div>
            <s-tooltip id={`tooltip-${uniqueId}`}>{tooltipContent}</s-tooltip>
        </div>
    );
}

interface STooltipWrapperProps {
    children: React.ReactNode;
    uniqueId: string;
    tooltipContent: string;
    disabled?: boolean;
}
